
























import Vue from 'vue';
import { Component, InjectReactive, Prop } from 'vue-property-decorator';
import AlgoliaCSGHits from 'frontend/components/search/AlgoliaCSGHits.vue';
import AlgoliaCourseHits from 'frontend/components/search/AlgoliaCourseHits.vue';
import NoAlgoliaHits from 'frontend/components/search/NoAlgoliaHits.vue';
import { getTestId } from 'frontend/utils/test-id';
import { Optional } from 'frontend/types';

@Component({
  components: {
    AlgoliaCSGHits,
    AlgoliaCourseHits,
    NoAlgoliaHits,
  },
})
export default class SearchQueryResults extends Vue {
  @InjectReactive() readonly csgHits!: any[];
  @InjectReactive() readonly coursesHits!: any[];
  @InjectReactive() readonly csgQueryID!: string;
  @InjectReactive() readonly courseQueryID!: string;
  @Prop(Boolean) private inHeader!: boolean;
  @Prop(Boolean) private mobile!: boolean;
  @Prop(Boolean) private isStaffUser!: boolean;
  @Prop(String) private readonly testIdPrefix: Optional<string>;

  private get testId(): string {
    return getTestId(this.testIdPrefix, 'results');
  }

  private get key() {
    return this.$vnode.key;
  }

  private onWheel(e: Event) {
    const { clientHeight: height, scrollHeight, scrollTop } = e.currentTarget as HTMLElement;
    const { deltaY } = e as WheelEvent;

    if (deltaY !== 0) {
      const up = deltaY < 0;
      // prevent scrolling when top/bottom edge of the content is reached
      // to prevent the whole page from scrolling
      if ((up && scrollTop === 0) || (!up && scrollTop + height === scrollHeight)) {
        e.preventDefault();
      }
    }
  }
}
